import { render, staticRenderFns } from "./PageDesign.vue?vue&type=template&id=37ae92d6&scoped=true&"
import script from "./PageDesign.vue?vue&type=script&lang=js&"
export * from "./PageDesign.vue?vue&type=script&lang=js&"
import style0 from "./PageDesign.vue?vue&type=style&index=0&id=37ae92d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae92d6",
  null
  
)

export default component.exports